var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgERxNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#516983;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,20.48v4.41a2.9,2.9,0,0,0,2.9,2.9H17.1a2.9,2.9,0,0,0,2.9-2.9V6.59a2.9,2.9,0,0,0-2.9-2.9H14.91V3.37a1,1,0,0,0-1-1h-1.3a2.67,2.67,0,0,0-5.24,0H6.08a1,1,0,0,0-1,1v.32H2.9A2.9,2.9,0,0,0,0,6.59ZM7.08,4.36H8.41a1,1,0,0,0,.95-1.29,1,1,0,0,1,0-.2.68.68,0,0,1,1.36,0,1,1,0,0,1,0,.2,1,1,0,0,0,.95,1.29h1.33v1H7.08ZM2,6.59a.91.91,0,0,1,.91-.91H5.09v.69a1,1,0,0,0,1,1h7.84a1,1,0,0,0,1-1V5.68H17.1a.91.91,0,0,1,.91.91v18.3a.91.91,0,0,1-.91.91H2.9A.91.91,0,0,1,2,24.89V6.59Zm3.53,11.9H7.23V20.2a1,1,0,0,0,1,1h3.54a1,1,0,0,0,1-1V18.49h1.71a1,1,0,0,0,1-1V14a1,1,0,0,0-1-1H12.77V11.24a1,1,0,0,0-1-1H8.23a1,1,0,0,0-1,1V13H5.52a1,1,0,0,0-1,1V17.5A1,1,0,0,0,5.52,18.49Zm1-3.55H8.23a1,1,0,0,0,1-1V12.24h1.56V14a1,1,0,0,0,1,1h1.72V16.5H11.77a1,1,0,0,0-1,1v1.71H9.22V17.5a1,1,0,0,0-1-1H6.51Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgERxNormal);
export default __webpack_public_path__ + "static/media/eRx_Normal.5bb4c1202235f9f3c938b1ca2e5a61c5.svg";
export { ForwardRef as ReactComponent };